// Main App component
import { AppRouter } from './routes';
import { useOrySession } from '@hooks';
import './styles/index.css';

function App() {
  // Initialize and sync Ory session on app load
  useOrySession();

  return <AppRouter />;
}

export default App;
